import { Grid, Hidden, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import FormComponent from '../components/FormComponent/FormComponent';
import BtnComponent from '../components/buttonComponent/BtnComponent';
import { useContext, useState } from 'react';
import CarouselWrapper from '../components/CarouselComponent/CarouselWrapper';
import { Link } from 'react-router-dom';
import GlobalContext from '../context/globalContext';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import useAuth from '../services/hooks/useAuth';
import { isObjectEmpty } from '../shared/helper';
import { STORAGE_KEYS } from '../shared/constants';
import { LOGIN } from '../shared/Strings';

const createAccountValues = {
  email: '',
  phonenumber: '',
  password: '',
  confirmpassword: '',
};

function Login() {
  const { carousel } = useContext(GlobalContext);
  const { login, loading } = useAuth();
  const [accountFormValues, setAccountFormValues] =
    useState(createAccountValues);
  const [accountFormErrors, setAccountFormErrors] = useState({});

  const accountHandleChange = e => {
    const { name, value } = e.target;
    setAccountFormValues({ ...accountFormValues, [name]: value });
  };

  const accountHandleSubmit = e => {
    e.preventDefault();
    setAccountFormErrors(accountValidate(accountFormValues));
    const userName = e.target.elements.email.value;
    const password = e.target.elements.password.value;
    if (isObjectEmpty(accountValidate(accountFormValues))) {
      login(userName, password);
    }
  };

  const accountValidate = values => {
    const errors = {};
    // const mailregex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i; <--- Wrong regex. Use library
    // const passwordregex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]$/;

    if (!values.email) {
      errors.email = LOGIN.ERROR.email;
      // } else if (!mailregex.test(values.email)) {
      //   errors.email = 'This is not a valid email';
    }

    if (!values.password) {
      errors.password = LOGIN.ERROR.password;
    }
    // else if (!passwordregex.test(values.password)) {
    //   errors.password = 'Must include an upper case letter, a lower case letter, a number and a special character';
    // }

    return errors;
  };

  const inputFieldArray = [
    {
      title: LOGIN.LABEL.email,
      placeholder: LOGIN.PLACE_HOLDER.email,
      type: 'text',
      name: 'email',
      value: accountFormValues.email,
      onChange: accountHandleChange,
      errorMessage: accountFormErrors.email,
    },
    {
      title: LOGIN.LABEL.password,
      placeholder: LOGIN.PLACE_HOLDER.password,
      type: 'password',
      onChange: accountHandleChange,
      name: 'password',
      value: accountFormValues.password,
      errorMessage: accountFormErrors.password,
    },
  ];

  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Hidden mdDown>
        <Grid item xs={false} sm={false} md={5}>
          <CarouselWrapper carouselConfig={carousel} />
        </Grid>
      </Hidden>
      <Grid
        item
        xs={12}
        md={7}
        component={Paper}
        square
        sx={{
          display: 'flex',
          justifyContent: 'center',
          background: '#f7f7f7',
        }}>
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            m: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          <Typography marginRight={1}>{LOGIN.DONT_HAVE_TEXT}</Typography>
          <BtnComponent
            component={Link}
            to={'/signup'}
            size="small"
            title={LOGIN.SIGN_UP_TEXT}></BtnComponent>
        </Box>
        <Box
          sx={{
            my: 7,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
            overflow: 'hidden',
            minWidth: { xs: '80vw', sm: '60vw', md: '35vw' },
          }}>
          {window.localStorage.getItem(STORAGE_KEYS.WELCOME_BACK) && (
            <Typography variant="h5" sx={{ mb: 2, color: '#8C8C8C' }}>
              {LOGIN.WELCOME_HEADING}
            </Typography>
          )}
          <Typography variant="title">{LOGIN.BTN_TEXT_LOGIN}</Typography>
          <Box component="form" onSubmit={accountHandleSubmit} sx={{ mt: 5 }}>
            <FormComponent inputFieldArray={inputFieldArray}></FormComponent>
            <Box sx={{ mt: 1 }}>
              <Typography
                component={Link}
                to={'/forgotPassword'}
                sx={{ textDecoration: 'none' }}
                variant="body2"
                color="primary">
                {LOGIN.FORGOTE_PASS_TEXT}
              </Typography>
            </Box>
            <BtnComponent
              data-testid="submit"
              type="submit"
              title={LOGIN.BTN_TEXT_LOGIN}
              fullWidth
              sx={{ mt: 4 }}></BtnComponent>
          </Box>
        </Box>
      </Grid>
      <SimpleBackdrop open={loading} />
    </Grid>
  );
}

export default Login;
